module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-icon-4.e2bfc1b4f8615ca16a8f606821516744.png";